import { render, staticRenderFns } from "./Catalog-Search.vue?vue&type=template&id=fa9dfc80&lang=pug"
import script from "./Catalog-Search.vue?vue&type=script&setup=true&lang=ts"
export * from "./Catalog-Search.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports